<template>
  <v-card :color="color" class="pt-2 pb-4 px-3" outlined>
    <div>
      <small class="text-uppercase">{{ title }}</small>
    </div>
    <div>
      <strong><slot /></strong>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'BaseNumbercard',
  props: {
    title: {
      required: true,
      type: String,
    },
    color: {
      default: undefined,
      type: String,
    },
  },
};
</script>
